import { CopyCellToClipboard } from "./CopyCellToClipboard";
import { EmptyCell } from "./EmptyCell";

export const StringCell: React.FC = ({
  value,
  columnDef: { canCopy },
}: any) => {
  return value === undefined ? (
    <EmptyCell />
  ) : (
    <span className="group flex max-w-[500px] justify-start gap-2 whitespace-normal">
      {value} {canCopy === true && <CopyCellToClipboard value={value} />}
    </span>
  );
};
